import { render, staticRenderFns } from "./UserViewUserPlanCard.vue?vue&type=template&id=5f02fc52&scoped=true"
import script from "./UserViewUserPlanCard.vue?vue&type=script&lang=js"
export * from "./UserViewUserPlanCard.vue?vue&type=script&lang=js"
import style0 from "./UserViewUserPlanCard.vue?vue&type=style&index=0&id=5f02fc52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f02fc52",
  null
  
)

export default component.exports